import React, { useCallback } from 'react';
import styles from "./InterstateIndividual.module.scss";
import {withRouter} from 'react-router-dom';
import { InterStateContactDetails } from "../../../components/importExport/interStateContactDetails/InterStateContactDetails";
import {useSelector,useDispatch} from 'react-redux';
import {storeInterStateDetails, saveImportExportApplication, storeImportExportDetails} from "../../../redux/actions";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";

const InterstateIndividual = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();
  const interStateDetails = useSelector(state => state.interStateDetails);
  const importExportDetails = useSelector(state => state.importExportDetails);

  const storeData = (interStateDetails, finished) => {
    var newInterStateDetails = {
      ...interStateDetails,
      // step: 2,
      // finished: finished,
      isIndividualValid: finished
    }

    dispatch(
      storeInterStateDetails(newInterStateDetails)
    );

    const importExportDetailsData = {
      ...importExportDetails,
      interStateDecisionAppTypeStep: 2,
      interStateDecisionAppTypeFinished: finished
    };

   dispatch(storeImportExportDetails(importExportDetailsData));    

  }; 

  const continueButtonHandler = useCallback(
    (interStateDetails) => {
      storeData(interStateDetails, true);
      dispatch(
        saveImportExportApplication("", () => {
          props.history.push(`./dashboard`);
        })
      );
    },
    []
  );

  const saveExitButtonHandler  = useCallback(
    (interStateDetails) => {

      storeData(interStateDetails);
      dispatch(
        saveImportExportApplication("", () => {
            props.history.push(`./dashboard`);
        })
      );
    },
    []
  );

  // const addressTile = importExportDetails.interStateDecisionAppType === 'Organisation' ? 'Business Address' : 'Address'
  return (
      <div className={styles.mainCont}>
          <InterStateContactDetails 
            continueButtonHandler={continueButtonHandler}
            interStateData={interStateDetails}  
            addressTitle = {`Postal Address (Australian address only)`}
            interStateDecisionAppType = {importExportDetails.interStateDecisionAppType}
            saveExitButtonHandler = {saveExitButtonHandler}
          />
      </div>
  );
};

export default withRouter(props => <InterstateIndividual {...props} />);
